
import Carouse from './Carouse'
import React,{ useEffect, useRef, useState } from "react";



export default function Home() {
 const cards = [

  {
    title: "Career Counselling",
    desc: "Get expert guidance to choose the right degree, university and career path.",
    active: false,
  },

  {
    title: "University Admissions",
    desc: "Complete support for admissions, documentation and application processes.",
    active: true,
  },

  {
    title: "Professional Courses",
    desc: "Industry-oriented courses designed to improve practical skills and employability.",
    active: false,
  },

  {
    title: "Placement Assistance",
    desc: "Resume building, interview preparation and placement support for students.",
    active: false,
  },

];

const legends = [

  {
    name: "Sales Performance",
    class: "blue",
  },

  {
    name: "Market Share",
    class: "yellow",
  },

  {
    name: "Website Traffic",
    class: "green",
  },

];
  

 const sectionRef = useRef(null);

  const [startCount, setStartCount] = useState(false);

  const [students, setStudents] = useState(0);
  const [placement, setPlacement] = useState(0);
  const [partners, setPartners] = useState(0);

  /* OBSERVER */

  useEffect(() => {

    const observer = new IntersectionObserver(

      ([entry]) => {

        if (entry.isIntersecting) {
          setStartCount(true);
        }

      },

      {
        threshold:0.4,
      }

    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };

  }, []);

  /* COUNTER */

  useEffect(() => {

    if (!startCount) return;

    let s = 0;
    let p = 0;
    let h = 0;

    const interval = setInterval(() => {

      if (s < 5200) {
        s += 50;
        setStudents(s);
      }

      if (p < 92) {
        p += 1;
        setPlacement(p);
      }

      if (h < 65) {
        h += 1;
        setPartners(h);
      }

    }, 30);

    return () => clearInterval(interval);

  }, [startCount]);





// slider--------------




// slider--------------










  return (
    <>





{/* ------------Slider-------------------------------- */}

<Carouse></Carouse>

{/* ------------Slider-------------------------------- */}



{/* bts---------------------------------------------------------- */}



<section className="placement-section">

  <div className="placement-left">

    <span className="placement-tag">
      about our company
    </span>

    <h1>
      Broadways Training Services
    </h1>

    <p className="placement-desc">
      Broadways Training Services is a leading provider of Training Services and
      Education Consultancy for University Degree Programs in India, with a
      centrally located office in Delhi.

      Started in 2022, Broadways Training Services is part of the Broadways
      group, which was established in 1992 and has almost 35 years of
      experience in the Education and Training Sectors.

      Led by an experienced management team, Broadways Training Services
      promises to provide you with the right Career Guidance and hold your hand
      in your journey towards Higher Education that will help you achieve your
      Career aspirations.
    </p>

  </div>

  <div className="placement-right">

    <div className="image-grid">

      <img
        className="img1"
        src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800"
        alt="Students"
      />

      <div className="experience-card">
        <h2>35+</h2>
        <p>Years Experience</p>
      </div>

      <div className="course-card">
  <h2>25+</h2>
  <p>Professional Courses</p>
</div>

      <img
        className="img2"
        src="https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=800"
        alt="Training"
      />

      <img
        className="img3"
        src="https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=1200"
        alt="Education"
      />

    </div>

  </div>

</section>


<section className="business-section">

  <div className="business-container">

    <div className="left-content">

      <h1>
        Why Choose <span>Broadways</span>
      </h1>

      <p className="description">
        Broadways Training Services provides expert career guidance,
        university admission support, professional courses and
        placement assistance to help students achieve their goals.
      </p>

      <div className="cards">

        <div className="card">
          <div className="icon">🎯</div>
          <h3>Career Counselling</h3>
          <p>
            Get expert guidance to choose the right degree,
            university and career path.
          </p>
        </div>

        <div className="card active-card">
          <div className="icon white-icon">🎓</div>
          <h3>University Admissions</h3>
          <p>
            Complete support for admissions, documentation
            and application processes.
          </p>
        </div>

        <div className="card">
          <div className="icon">💻</div>
          <h3>Professional Courses</h3>
          <p>
            Industry-oriented courses designed to improve
            practical skills and employability.
          </p>
        </div>

        <div className="card">
          <div className="icon">💼</div>
          <h3>Placement Assistance</h3>
          <p>
            Resume building, interview preparation and
            placement support for students.
          </p>
        </div>

      </div>

    </div>

  </div>

</section>


{/* bts---------------------------------------------------------- */}



















{/* ------------about-------------------------------- */}

<section className="collab-section">

  <span className="collab-tag">
    Our Collaborations
  </span>

  <h2>
    Trusted University Partners
  </h2>

  <p>
    Thousands of students are successfully pursuing
    online degree programs through our university
    collaborations.
  </p>

  <div className="collab-wrapper">

    <div className="student-img student1">

  <div className="study-circle">
    🎓
  </div>

  <div className="student-badge">
    Online Learner
  </div>

</div>

    <div className="universities">

      <div className="logo-card">
        <img src="/mujlogo.png" alt="" />
        <h3>Manipal University Jaipur</h3>
      </div>

      <div className="logo-card mb-5">
        <img src="/smulogo.png" alt="" />
        <h3>Sikkim Manipal University</h3>
      </div>

    </div>

   <div className="student-img student2">

  <div className="study-circle">
    📚
  </div>

  <div className="student-badge">
    Career Growth
  </div>

</div>

  </div>

</section>

{/* ------------about-------------------------------- */}

        {/* incsection */}

    <section
      className="counter-section"
      ref={sectionRef}
    >

      <div className="counter-overlay"></div>

      <div className="counter-container">

        {/* TOP */}

        <div className="counter-top">

          <h1>
            Join Us And Achieve <br />
            Future Goal
          </h1>

          <p>
            Broadways Training Services helps students
            achieve career success with professional
            training and placement support.
          </p>

        </div>

        {/* COUNTERS */}

        <div className="counter-grid">

          <div className="counter-box">

            <h2>
              +{students.toLocaleString()}
            </h2>

            <span>
              Happy Students
            </span>

          </div>

          <div className="counter-box">

            <h2>
              {placement}%
            </h2>

            <span>
              Placement Success
            </span>

          </div>

          <div className="counter-box">

            <h2>
              +{partners}
            </h2>

            <span>
              Hiring Partners
            </span>

          </div>

        </div>

      </div>

    </section>

        {/* incsection */}


        {/* -------------------------------testomonials------------ */}



        {/* -------------------------------testomonials------------ */}










   
    </>




  )
}
